<template>
  <router-view ></router-view>
</template>

<script>
  export default {
    name: "import-wrapper"
  }
</script>

<style scoped>

</style>
